import { render, staticRenderFns } from "./MtrlEditAppr.vue?vue&type=template&id=d362489e&scoped=true&"
import script from "./MtrlEditAppr.vue?vue&type=script&lang=js&"
export * from "./MtrlEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d362489e",
  null
  
)

export default component.exports